module.exports = __webpack_public_path__ + "static/avatar_mihail_bashtakov-bdf6e762a46ded9a2868213e681577fc.jpg";